
        import { createElement as _createElement } from 'react';
import { Fragment as _Fragment } from 'react';
import _map from 'lodash-es/map';
export default function dialogButtonMobileRT () {
    return _createElement('div', { 'className': 'cm_search-box-root__dialog_open-button' }, [this.searchBoxDialogButton(function () {
            return _createElement('div', { 'className': 'cm_desktop-hide  cm_searchBoxDialogButton' }, _createElement('svg', {
                'className': 'cm_icon',
                'width': '16',
                'height': '16',
                'viewBox': '0 0 16 16',
                'fill': 'none',
                'xmlns': 'http://www.w3.org/2000/svg'
            }, _createElement('path', {
                'd': 'M12.0203 11.078L14.8757 13.9327L13.9323 14.876L11.0777 12.0207C10.0155 12.8722 8.69434 13.3353 7.33301 13.3334C4.02101 13.3334 1.33301 10.6454 1.33301 7.33337C1.33301 4.02137 4.02101 1.33337 7.33301 1.33337C10.645 1.33337 13.333 4.02137 13.333 7.33337C13.3349 8.69471 12.8718 10.0159 12.0203 11.078ZM10.683 10.5834C11.5291 9.7133 12.0016 8.54699 11.9997 7.33337C11.9997 4.75537 9.91101 2.66671 7.33301 2.66671C4.75501 2.66671 2.66634 4.75537 2.66634 7.33337C2.66634 9.91137 4.75501 12 7.33301 12C8.54663 12.002 9.71293 11.5294 10.583 10.6834L10.683 10.5834Z',
                'fill': '%23232833'
            })));
        }, {
            widgetName: 'undefined',
            items: undefined
        })]);
}
        export const componentNames = ["cm:searchBoxDialogButton"]